import { render } from "./RegisterResume.vue?vue&type=template&id=76734719&ts=true"
import script from "./RegisterResume.vue?vue&type=script&lang=ts"
export * from "./RegisterResume.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__